import { supabase } from '@/integrations/supabase/client';

export interface PatientReferrerOption {
  clinic_id: string;
  clinic_name: string;
  doctor_id: string | null;
  doctor_name: string | null;
}

// Use the existing names-only directory RPC, never the full contact tables.
export async function getPatientReferrerDirectory(): Promise<PatientReferrerOption[]> {
  const rows: PatientReferrerOption[] = [];
  for (let from = 0; ; from += 1000) {
    const { data, error } = await supabase
      .rpc('get_referring_directory' as never)
      .order('clinic_id').order('doctor_id').range(from, from + 999);
    if (error) throw error;
    const page = (data ?? []) as unknown as PatientReferrerOption[];
    rows.push(...page.filter((row) => row.clinic_id && row.clinic_name?.trim() && row.clinic_name !== '[Blank]'));
    if (page.length < 1000) return rows;
  }
}
